import { render, staticRenderFns } from "./TrafficModify.vue?vue&type=template&id=f419e5a6"
import script from "./TrafficModify.vue?vue&type=script&lang=js"
export * from "./TrafficModify.vue?vue&type=script&lang=js"
import style0 from "./TrafficModify.vue?vue&type=style&index=0&id=f419e5a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports